// extracted by mini-css-extract-plugin
module.exports = {"btn_submit":"buttons-module--btn_submit--2WsE-"};